import { rules } from './rules';

export const validator = {
  rules,
  std_form_error: 'Validation error, check the form.'
};
// export const validator = {
//   required: 'The field is required',
//   rules: {
//     accepted: '@:validator.required',
//     email: '@:validator.required',
//     max: 'The field may not be greater than 128 characters',
//     min: 'The Password field must be at least 6 characters.',
//     password: '@:validator.required',
//     phone: '@:validator.required',
//     required: '@:validator.required',
//     required_recipient: '@:validator.required',
//     url: 'The field format is invalid'
//   },
//   std_form_error: 'Validasi error, check the form.'
// };
